import React, { Component } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { routes } from "./paths";
import { AnalyticsService } from "../utils/Analytics";
import Login from "../screens/login/login";
import ChangePassword from "../screens/changePassword/changePassword";
import Dashboard from "../screens/dashboard/dashboard";
import DispatchTimer from "../screens/dispatchTimer/dispatchTimer";
import Marketing from "../screens/marketing/marketing";
import Merchants from "../screens/merchants/merchants";
import Summary from "../screens/summary/summary";
import Payments from "../screens/payments/payments";
import Settings from "../screens/settings/settings";
import ThirdPartyIntegration from "../screens/ThirdPartyIntegration/ThirdPartyIntegration";
import OnBoardSportsShops from	"../screens/OnBoardingScreens/SportsShops";
import AcceptTopDealProductPrice from "../screens/AcceptTopDealProductPrice/AcceptTopDealProductPrice"
import { AppHeader, LeftMenu } from "../components/organisms";
import  OnBoardingHeader from "../components/organisms/OnBoardingHeader/OnBoardingHeader";
import ResetPassword from "../screens/resetPassword/resetPassword";

function AuthRoute({ children }) {
  const authenticated = localStorage.getItem("isAuthenticated");
  if (authenticated === "false") {
    return <Navigate to="/" />;
  }
  return children;
}

function AppLayout({ children }) {
  const navigate = useNavigate();
  const userName = localStorage.getItem("userName");

  const handleSignout = () => {
    const userEmail = localStorage.getItem("userEmail");
    AnalyticsService.logEvent("USER_LOGGED_OUT", {
      userEmail: userEmail,
    });
    AnalyticsService.identifyUser(null);
    localStorage.clear();
    localStorage.setItem("isAuthenticated", false);
    navigate("/");
  };

  return (
    <div style={{ minHeight: "100%" }}>
      <AppHeader
        upperText={userName}
        bottomText={`Portal`}
        linkText={"Signout"}
        Signout={handleSignout}
      />
      <div className="midColumn">
        <div className="leftMenuParent h-100">
          <LeftMenu />
        </div>
        {children}
      </div>
    </div>
  );
}

function OnBoardLayout({ children }) {
 
 

  return (
    <div style={{ minHeight: "100%" }}>
      <OnBoardingHeader
       
      />
      <div className="onBoardPanelCls">
        
        {children}
      </div>
    </div>
  );
}

class Router extends Component {
  render() {
    return (
      <>
        <Routes>
          <Route
            exact
            path={routes.dashboard}
            element={
              <AuthRoute>
                <AppLayout>
                  <Dashboard />
                </AppLayout>
              </AuthRoute>
            }
          />
          <Route
            exact
            path={routes.acceptPriceChange}
            element={
              <AuthRoute>
                <AppLayout>
                  <AcceptTopDealProductPrice />
                </AppLayout>
              </AuthRoute>
            }
          />
          <Route
            exact
            path={`${routes.dashboard}/:parameterName`}
            element={
              <AuthRoute>
                <AppLayout>
                  <Dashboard />
                </AppLayout>
              </AuthRoute>
            }
          />
          <Route exact path={routes.login} element={<Login />} />
          <Route
            exact
            path={routes.changePassword}
            element={<ChangePassword />}
          />
          <Route
            exact
            path={routes.resetPassword}
            element={<ResetPassword />}
          />
          <Route
            exact
            path={routes.settings}
            element={
              <AuthRoute>
                <AppLayout>
                  <Settings />
                </AppLayout>
              </AuthRoute>
            }
          />
          <Route
            exact
            path={routes.dispatchTimer}
            element={
              <AuthRoute>
                <AppLayout>
                  <DispatchTimer />
                </AppLayout>
              </AuthRoute>
            }
          />
          <Route
            exact
            path={routes.marketing}
            element={
              <AuthRoute>
                <AppLayout>
                  <Marketing />
                </AppLayout>
              </AuthRoute>
            }
          />
           <Route
            exact
            path={routes.merchants}
            element={
              <AuthRoute>
                <AppLayout>
                  <Merchants />
                </AppLayout>
              </AuthRoute>
            }
          />
          <Route
            exact
            path={routes.thirdParty}
            element={
              <AuthRoute>
                <AppLayout>
                  <ThirdPartyIntegration />
                </AppLayout>
              </AuthRoute>
            }
          />
          <Route
            exact
            path={routes.payments}
            element={
              <AuthRoute>
                <AppLayout>
                  <Payments />
                </AppLayout>
              </AuthRoute>
            }
          />
          <Route
            exact
            path={routes.summary}
            element={
              <AuthRoute>
                <AppLayout>
                  <Summary />
                </AppLayout>
              </AuthRoute>
            }
          />
           <Route
            exact
            path={routes.sportsShopOnBoard}
            element={
             <OnBoardLayout>
                  <OnBoardSportsShops />
             </OnBoardLayout>
            }
          />
        </Routes>
        
      </>
    );
  }
}

export default Router;
